import { pick } from "lodash-es";
import { z } from "zod";
import { createLabeledEnum } from "./labeled-enum";

export const allOperators = createLabeledEnum({
  After: "Efter",
  Before: "Før",
  Between: "Mellem",
  BetweenDaysAgo: "Mellem dage siden",
  BetweenMonthsAgo: "Mellem måneder siden",
  BetweenWeeksAgo: "Mellem uger siden",
  BetweenYearsAgo: "Mellem år siden",
  Contains: "Indeholder",
  DoesNotBeginWith: "Starter ikke med",
  DoesNotContain: "Indeholder ikke",
  DoesNotEndWith: "Slutter ikke med",
  EndsWith: "Slutter med",
  Equal: "Lig med",
  GreaterEqual: "Mere end eller lig med",
  GreaterThan: "Mere end",
  LessEqual: "Mindre end eller lig med",
  LessThan: "Mindre end",
  LessThanDaysAgo: "Mindre end dage siden",
  LessThanMonthsAgo: "Mindre end måneder siden",
  LessThanWeeksAgo: "Mindre end uger siden",
  LessThanYearsAgo: "Mindre end år siden",
  ListContains: "Indeholder",
  ListDoesNotContain: "Indeholder ikke",
  MoreThanDaysAgo: "Mere end dage siden",
  MoreThanMonthsAgo: "Mere end måneder siden",
  MoreThanWeeksAgo: "Mere end uger siden",
  MoreThanYearsAgo: "Mere end år siden",
  NotEqual: "Ikke lig med",
  StartsWith: "Starter med",
  HasLabel: "Har",
  DoesNotHaveLabel: "Har ikke",
});

export const numericOperators = createLabeledEnum(
  pick(allOperators.values, [
    "GreaterThan",
    "LessThan",
    "Between",
    "Equal",
    "NotEqual",
    "GreaterEqual",
    "LessEqual",
  ]),
);

export const listOperators = createLabeledEnum(
  pick(allOperators.values, ["ListContains", "ListDoesNotContain"]),
);

export const dateOperators = createLabeledEnum(
  pick(allOperators.values, [
    "MoreThanDaysAgo",
    "MoreThanWeeksAgo",
    "MoreThanMonthsAgo",
    "MoreThanYearsAgo",
    "LessThanDaysAgo",
    "LessThanWeeksAgo",
    "LessThanMonthsAgo",
    "LessThanYearsAgo",
    "BetweenDaysAgo",
    "BetweenWeeksAgo",
    "BetweenMonthsAgo",
    "BetweenYearsAgo",
    "GreaterThan",
    "LessThan",
    "Before",
    "After",
    "Between",
  ]),
);

export const dateOperatorsWithBetween = createLabeledEnum(
  pick(allOperators.values, ["GreaterThan", "LessThan", "Between"]),
);

export const numericOperatorsWithBetween = createLabeledEnum(
  pick(allOperators.values, ["GreaterThan", "LessThan", "Between"]),
);

export const textOperators = createLabeledEnum(
  pick(allOperators.values, [
    "Contains",
    "DoesNotContain",
    "StartsWith",
    "EndsWith",
    "DoesNotBeginWith",
    "DoesNotEndWith",
    "Equal",
    "NotEqual",
  ]),
);

export const labelOperators = createLabeledEnum(
  pick(allOperators.values, ["HasLabel", "DoesNotHaveLabel"]),
);

export const comparisonOperators = createLabeledEnum(
  pick(allOperators.values, ["Equal", "NotEqual"]),
);

// Not sure if we would rather make the comparisonOperators a function with an
// options argument.
export const comparisonWithBetweenOperators = createLabeledEnum(
  pick(allOperators.values, ["Equal", "NotEqual", "Between"]),
);

export type DateOperator = z.infer<typeof dateOperators.enum>;
export type DateOperatorWithBetween = z.infer<
  typeof dateOperatorsWithBetween.enum
>;
export type NumericOperator = z.infer<typeof numericOperators.enum>;
export type TextOperator = z.infer<typeof textOperators.enum>;
export type ComparisonOperator = z.infer<typeof comparisonOperators.enum>;
export type ComparisonWithBetweenOperator = z.infer<
  typeof comparisonWithBetweenOperators.enum
>;
export type NumericOperatorWithBetween = z.infer<
  typeof numericOperatorsWithBetween.enum
>;
export type ListOperator = z.infer<typeof listOperators.enum>;
export type LabelOperator = z.infer<typeof labelOperators.enum>;
